// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_l-0";
export var skeletonCard = "_l-1";